import { Observable } from 'rxjs';
import GraphQLAPI, { GraphQLResult, GRAPHQL_AUTH_MODE } from '@aws-amplify/api-graphql';

//  All these are auto-generated
import * as codegenapi from '../graphql/API';
import * as codegenqueries from '../graphql/queries';
import * as codegensubscriptions from '../graphql/subscriptions';
import * as codegenmutations from '../graphql/mutations';

//  We need an interface to enable faking/mocking
//  TODO: Better way to do this?
export interface IGQLClient {
    gqlAddActivity(subjectid: string, activitytypeid: string, startTime: number, stopTime: number, comment: string | undefined | null): Promise<codegenapi.GetActivityQuery>;
    gqlAddActivityType(studyid: string, description: string): Promise<codegenapi.GetActivityTypeQuery>;
    gqlAddDevice(siteid: string, deviceid: string): Promise<codegenapi.GetDeviceQuery>;
    gqlAddForm(subjectid: string, formtypeid: string, fields: codegenapi.KeyValuePair[]): Promise<codegenapi.GetFormQuery>;
    gqlAddFormType(studyid: string, identifier: string, fields: codegenapi.FormTypeFieldInput[] | undefined): Promise<codegenapi.GetFormTypeQuery>;
    gqlAddReferenceData(siteid: string, studyid: string, subjectid: string, identifier: string | undefined | null, activitytypeid: string, filename: string): Promise<codegenapi.GetReferenceDataQuery>;
    gqlAddSite(siteid: string, name: string): Promise<codegenapi.GetSiteQuery>;
    gqlAddStudy(siteid: string, name: string): Promise<codegenapi.GetStudyQuery>;
    gqlAddSubject(siteid: string, studyid: string, subjectid: string, devices: codegenapi.SubjectDevice[] | undefined): Promise<codegenapi.GetSubjectQuery>;
    gqlAddSubjectV2(siteid: string, studyid: string, identifier: string, devices: codegenapi.SubjectDevice[] | undefined): Promise<codegenapi.GetSubjectQuery>;
    gqlCloseSubject(siteid: string, studyid: string, subjectid: string, identifier: string | undefined |null, devices: codegenapi.SubjectDevice[] | null | undefined, snapshot: string): Promise<codegenapi.GetSubjectQuery>;
    gqlGetActivityType(studyid: string, activitytypeid: string): Promise<codegenapi.GetActivityTypeQuery>;
    gqlGetForm(subjectid: string, formtypeid: string): Promise<codegenapi.GetFormQuery>;
    gqlGetFormType(studyid: string, formtypeid: string): Promise<codegenapi.GetFormTypeQuery>;
    gqlGetSite(siteid: string): Promise<codegenapi.GetSiteQuery>;
    gqlGetStudy(siteid: string, studyid: string): Promise<codegenapi.GetStudyQuery>;
    gqlGetSubject(studyid: string, subjectid: string): Promise<codegenapi.GetSubjectQuery>;
    gqlGetSubjectSnapshot(studyid: string, subjectid: string): Promise<codegenapi.GetSubjectQuery>;
    gqlListActivities(subjectid: string): Promise<codegenapi.ListActivitiesQuery>;
    gqlListActivityTypes(studyid: string): Promise<codegenapi.ListActivityTypesQuery>;
    gqlListDevices(siteid: string): Promise<codegenapi.ListDevicesQuery>;
    gqlListForms(subjectid: string): Promise<codegenapi.ListFormsQuery>;
    gqlListFormTypes(studyid: string): Promise<codegenapi.ListFormTypesQuery>;
    gqlListReferenceData(subjectid: string): Promise<codegenapi.ListReferenceDataQuery>;
    gqlListSites(): Promise<codegenapi.ListSitesQuery>;
    gqlListSitesShallow(): Promise<codegenapi.ListSitesQuery>;
    gqlListStudies(siteid: string): Promise<codegenapi.ListStudiesQuery>;
    gqlListSubjects(studyid: string): Promise<codegenapi.ListSubjectsQuery>;
    gqlOnActivitiesUpdatesSubscription(subjectid: string): Promise<codegenapi.OnActivitiesUpdatesSubscription | Observable<codegenapi.OnActivitiesUpdatesSubscription>>;
    gqlOnActivityTypesUpdatesSubscription(studyid: string): Promise<codegenapi.OnActivityTypesUpdatesSubscription | Observable<codegenapi.OnActivityTypesUpdatesSubscription>>;
    gqlOnDevicesUpdatesSubscription(siteid: string): Promise<codegenapi.OnDevicesUpdatesSubscription | Observable<codegenapi.OnDevicesUpdatesSubscription>>;
    gqlOnFormsUpdatesSubscription(subjectid: string): Promise<codegenapi.OnFormsUpdatesSubscription | Observable<codegenapi.OnFormsUpdatesSubscription>>;
    gqlOnFormTypesUpdatesSubscription(studyid: string): Promise<codegenapi.OnFormTypesUpdatesSubscription | Observable<codegenapi.OnFormTypesUpdatesSubscription>>;
    gqlOnReferenceDataUpdatesSubscription(subjectid: string, activitytypeid: string): Promise<codegenapi.OnReferenceDataUpdatesSubscription | Observable<codegenapi.OnReferenceDataUpdatesSubscription>>;
    gqlOnStudiesUpdatesSubscription(siteid: string): Promise<codegenapi.OnStudiesUpdatesSubscription | Observable<codegenapi.OnStudiesUpdatesSubscription>>;
    gqlOnSubjectsUpdatesSubscription(studyid: string): Promise<codegenapi.OnSubjectsUpdatesSubscription | Observable<codegenapi.OnSubjectsUpdatesSubscription>>;
    gqlOnSubjectUpdatesSubscription(studyid: string, subjectid: string): Promise<codegenapi.OnSubjectUpdatesSubscription | Observable<codegenapi.OnSubjectUpdatesSubscription>>;
    gqlOnSitesUpdatesSubscription(): Promise<codegenapi.OnSitesUpdatesSubscription | Observable<codegenapi.OnSitesUpdatesSubscription>>;
    gqlRemoveActivity(subjectid: string, activitytypeid: string): Promise<any>;
    gqlRemoveActivityType(studyid: string, activitytypeid: string): Promise<any>;
    gqlRemoveDevice(siteid: string, deviceid: string): Promise<any>;
    gqlRemoveForm(subjectid: string, formtypeid: string): Promise<any>;
    gqlRemoveFormType(studyid: string, formtypeid: string): Promise<any>;
    gqlRemoveReferenceData(subjectid: string, referencedataid: string): Promise<any>;
    gqlRemoveSite(siteid: string): Promise<any>;
    gqlRemoveStudy(siteid: string, studyid: string): Promise<any>;
    gqlRemoveSubject(studyid: string, subjectid: string): Promise<any>;
    gqlUpdateActivity(subjectid: string, acivitytypeid: string, startTime: number, stopTime: number, comment: string | undefined | null): Promise<codegenapi.GetActivityQuery>;
    gqlUpdateActivityType(studyid: string, acivitytypeid: string, description: string): Promise<codegenapi.GetActivityTypeQuery>;
    gqlUpdateDevice(siteid: string, deviceid: string): Promise<codegenapi.GetDeviceQuery>;
    gqlUpdateForm(subjectid: string, formtypeid: string, fields: codegenapi.KeyValuePairInput[]): Promise<codegenapi.GetFormQuery>;
    gqlUpdateFormType(studyid: string, formtypeid: string, identifier: string, fields: codegenapi.FormTypeFieldInput[] | null | undefined): Promise<codegenapi.GetFormTypeQuery>;
    gqlUpdateSite(siteid: string, name: string): Promise<codegenapi.GetSiteQuery>;
    gqlUpdateSubject(siteid: string, studyid: string, subjectid: string, identifier: string | undefined | null, devices: codegenapi.SubjectDeviceInput[] | undefined | null): Promise<codegenapi.GetSubjectQuery>;
}

//  Manual interface, manual client
//  TODO: Better way to do this?
export class GQLClient implements IGQLClient {

    async gqlAddActivity(subjectid: string, activitytypeid: string, startTime: number, stopTime: number, comment: string | undefined | null = null): Promise<codegenapi.GetActivityQuery> {
        const mv: codegenapi.AddActivityMutationVariables = {
            input: {
                subjectid: subjectid,
                activitytypeid: activitytypeid,
                startTime: startTime,
                stopTime: stopTime,
                comment: comment,
            }
        };
        return (await GraphQLAPI.graphql<codegenapi.AddActivityMutation>({
            query: codegenmutations.addActivity,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetActivityQuery>).data as codegenapi.GetActivityQuery;
    }

    async gqlAddActivityType(studyid: string, description: string): Promise<codegenapi.GetActivityTypeQuery> {
        const mv: codegenapi.AddActivityTypeMutationVariables = { input: { studyid: studyid, description: description } };
        return (await GraphQLAPI.graphql<codegenapi.AddActivityTypeMutation>({
            query: codegenmutations.addActivityType,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetActivityTypeQuery>).data as codegenapi.GetActivityTypeQuery;
    }

    async gqlAddDevice(siteid: string, deviceid: string): Promise<codegenapi.GetDeviceQuery> {
        const mv: codegenapi.AddDeviceMutationVariables = { siteid: siteid, deviceid: deviceid };
        return (await GraphQLAPI.graphql<codegenapi.AddDeviceMutation>({
            query: codegenmutations.addDevice,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetDeviceQuery>).data as codegenapi.GetDeviceQuery;
    }

    async gqlAddForm(subjectid: string, formtypeid: string, fields: codegenapi.KeyValuePair[]): Promise<codegenapi.GetFormQuery> {
        const mv: codegenapi.AddFormMutationVariables = { input: { subjectid: subjectid, formtypeid: formtypeid, fields: fields } };
        return (await GraphQLAPI.graphql<codegenapi.AddFormMutation>({
            query: codegenmutations.addForm,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetFormQuery>).data as codegenapi.GetFormQuery;
    }

    async gqlAddFormType(studyid: string, identifier: string, fields: codegenapi.FormTypeFieldInput[] | undefined): Promise<codegenapi.GetFormTypeQuery> {
        const mv: codegenapi.AddFormTypeMutationVariables = { input: { studyid: studyid, identifier: identifier, fields: fields } };
        return (await GraphQLAPI.graphql<codegenapi.AddFormTypeMutation>({
            query: codegenmutations.addFormType,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetFormTypeQuery>).data as codegenapi.GetFormTypeQuery;
    }

    async gqlAddReferenceData(siteid: string, studyid: string, subjectid: string, identifier: string | undefined | null, activitytypeid: string, filename: string): Promise<codegenapi.GetReferenceDataQuery> {
        const mv: codegenapi.AddReferenceDataMutationVariables = {
            subjectid: subjectid,
            input: {
                activitytypeid: activitytypeid,
                filename: filename,
                siteid: siteid,
                studyid: studyid,
                identifier: identifier,
            }
        };
        return (await GraphQLAPI.graphql<codegenapi.AddReferenceDataMutation>({
            query: codegenmutations.addReferenceData,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetReferenceDataQuery>).data as codegenapi.GetReferenceDataQuery;
    }

    async gqlAddSite(siteid: string, name: string): Promise<codegenapi.GetSiteQuery> {
        const mv: codegenapi.AddSiteMutationVariables = {
            name: name,
            siteid: siteid,
        };
        return (await GraphQLAPI.graphql<codegenapi.AddSiteMutation>({
            query: codegenmutations.addSite,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetSiteQuery>).data as codegenapi.GetSiteQuery;
    }

    async gqlAddStudy(siteid: string, name: string): Promise<codegenapi.GetStudyQuery> {
        const mv: codegenapi.AddStudyMutationVariables = { siteid: siteid, name: name };
        return (await GraphQLAPI.graphql<codegenapi.AddStudyMutation>({
            query: codegenmutations.addStudy,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetStudyQuery>).data as codegenapi.GetStudyQuery;
    }

    async gqlAddSubject(siteid: string, studyid: string, subjectid: string, devices: codegenapi.SubjectDevice[] | undefined): Promise<codegenapi.GetSubjectQuery> {
        const mv: codegenapi.AddSubjectMutationVariables = {
            input: {
                siteid: siteid,
                studyid: studyid,
                subjectid: subjectid,
                devices: devices,
                status: codegenapi.SubjectStatusType.OPEN,
            }
        };
        return (await GraphQLAPI.graphql<codegenapi.AddSubjectMutation>({
            query: codegenmutations.addSubject,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetSubjectQuery>).data as codegenapi.GetSubjectQuery;
    }

    async gqlAddSubjectV2(siteid: string, studyid: string, identifier: string, devices: codegenapi.SubjectDevice[] | undefined): Promise<codegenapi.GetSubjectQuery> {
        const mv: codegenapi.AddSubjectV2MutationVariables = {
            input: {
                siteid: siteid,
                studyid: studyid,
                identifier: identifier,
                devices: devices,
                status: codegenapi.SubjectStatusType.OPEN,
            }
        };
        return (await GraphQLAPI.graphql<codegenapi.AddSubjectV2Mutation>({
            query: codegenmutations.addSubjectV2,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetSubjectQuery>).data as codegenapi.GetSubjectQuery;
    }

    async gqlCloseSubject(siteid: string, studyid: string, subjectid: string, identifier: string | undefined | null, devices: codegenapi.SubjectDevice[] | null | undefined, snapshot: string): Promise<codegenapi.GetSubjectQuery> {
        const mv: codegenapi.UpdateSubjectMutationVariables = {
            input: {
                devices: devices,
                subjectid: subjectid,
                siteid: siteid,
                identifier: identifier,
                snapshot: snapshot,
                studyid: studyid,
                status: codegenapi.SubjectStatusType.CLOSED,
            }
        };
        return (await GraphQLAPI.graphql<codegenapi.UpdateSubjectMutation>({
            query: codegenmutations.updateSubject,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetSubjectQuery>).data as codegenapi.GetSubjectQuery;
    }

    async gqlGetActivityType(studyid: string, activitytypeid: string): Promise<codegenapi.GetActivityTypeQuery> {
        const qv: codegenapi.GetActivityTypeQueryVariables = { studyid: studyid, activitytypeid: activitytypeid };
        return (await GraphQLAPI.graphql<codegenapi.GetActivityTypeQuery>({
            query: codegenqueries.getActivityType,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.GetActivityTypeQuery>).data as codegenapi.GetActivityTypeQuery;
    }

    async gqlGetForm(subjectid: string, formtypeid: string): Promise<codegenapi.GetFormQuery> {
        const qv: codegenapi.GetFormQueryVariables = { subjectid: subjectid, formtypeid: formtypeid };
        return (await GraphQLAPI.graphql<codegenapi.GetFormQuery>({
            query: codegenqueries.getForm,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.GetFormQuery>).data as codegenapi.GetFormQuery;
    }

    async gqlGetFormType(studyid: string, formtypeid: string): Promise<codegenapi.GetFormTypeQuery> {
        const qv: codegenapi.GetFormTypeQueryVariables = { studyid: studyid, formtypeid: formtypeid };
        return (await GraphQLAPI.graphql<codegenapi.GetFormTypeQuery>({
            query: codegenqueries.getFormType,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.GetFormTypeQuery>).data as codegenapi.GetFormTypeQuery;
    }

    async gqlGetSite(siteid: string): Promise<codegenapi.GetSiteQuery> {
        const qv: codegenapi.GetSiteQueryVariables = { siteid: siteid };
        return (await GraphQLAPI.graphql<codegenapi.GetSiteQuery>({
            query: codegenqueries.getSite,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.GetSiteQuery>).data as codegenapi.GetSiteQuery;
    }

    async gqlGetStudy(siteid: string, studyid: string): Promise<codegenapi.GetStudyQuery> {
        const qv: codegenapi.GetStudyQueryVariables = { siteid: siteid, studyid: studyid };
        return (await GraphQLAPI.graphql<codegenapi.GetStudyQuery>({
            query: codegenqueries.getStudy,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.GetStudyQuery>).data as codegenapi.GetStudyQuery;
    }

    async gqlGetSubject(studyid: string, subjectid: string): Promise<codegenapi.GetSubjectQuery> {
        const qv: codegenapi.GetSubjectQueryVariables = { studyid: studyid, subjectid: subjectid };
        return (await GraphQLAPI.graphql<codegenapi.GetSubjectQuery>({
            query: codegenqueries.getSubject,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.GetSubjectQuery>).data as codegenapi.GetSubjectQuery;
    }

    async gqlGetSubjectSnapshot(studyid: string, subjectid: string): Promise<codegenapi.GetSubjectQuery> {
        const qv: codegenapi.GetSubjectQueryVariables = { studyid: studyid, subjectid: subjectid };
        const query = `
            query getSubjectSnapshot($studyid: ID!, $subjectid: ID!) {
                getSubject(studyid: $studyid, subjectid: $subjectid) {
                    activities {
                        activitytype {
                            activitytypeid
                            description
                        }
                        comment
                        startTime
                        stopTime
                        referenceData {
                            referencedataid
                            activitytypeid
                            filename
                            persistedObjectName
                        }
                    }
                    devices {
                        deviceid
                        position
                    }
                    forms {
                        formtype {
                            identifier
                        }
                        fields {
                            key
                            value
                        }
                    }
                    siteid
                    studyid
                    subjectid
                    identifier
                }
            }`;
        return (await GraphQLAPI.graphql<codegenapi.GetSubjectQuery>({
            query: query,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.GetSubjectQuery>).data as codegenapi.GetSubjectQuery;
    }

    async gqlListActivities(subjectid: string): Promise<codegenapi.ListActivitiesQuery> {
        const qv: codegenapi.ListActivitiesQueryVariables = { subjectid: subjectid };
        return (await GraphQLAPI.graphql<codegenapi.ListActivitiesQuery>({
            query: codegenqueries.listActivities,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.ListActivitiesQuery>).data as codegenapi.ListActivitiesQuery;
    }

    async gqlListActivityTypes(studyid: string): Promise<codegenapi.ListActivityTypesQuery> {
        const qv: codegenapi.ListActivityTypesQueryVariables = { studyid: studyid };
        return (await GraphQLAPI.graphql<codegenapi.ListActivityTypesQuery>({
            query: codegenqueries.listActivityTypes,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.ListActivityTypesQuery>).data as codegenapi.ListActivityTypesQuery;
    }

    async gqlListDevices(siteid: string): Promise<codegenapi.ListDevicesQuery> {
        const qv: codegenapi.ListDevicesQueryVariables = { siteid: siteid };
        return (await GraphQLAPI.graphql<codegenapi.ListDevicesQuery>({
            query: codegenqueries.listDevices,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.ListDevicesQuery>).data as codegenapi.ListDevicesQuery;
    }

    async gqlListForms(subjectid: string): Promise<codegenapi.ListFormsQuery> {
        const qv: codegenapi.ListFormsQueryVariables = { subjectid: subjectid };
        return (await GraphQLAPI.graphql<codegenapi.ListFormsQuery>({
            query: codegenqueries.listForms,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.ListFormsQuery>).data as codegenapi.ListFormsQuery;
    }

    async gqlListFormTypes(studyid: string): Promise<codegenapi.ListFormTypesQuery> {
        const qv: codegenapi.ListFormTypesQueryVariables = { studyid: studyid };
        return (await GraphQLAPI.graphql<codegenapi.ListFormTypesQuery>({
            query: codegenqueries.listFormTypes,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.ListFormTypesQuery>).data as codegenapi.ListFormTypesQuery;
    }

    async gqlListReferenceData(subjectid: string): Promise<codegenapi.ListReferenceDataQuery> {
        const qv: codegenapi.ListReferenceDataQueryVariables = { subjectid: subjectid };
        return (await GraphQLAPI.graphql<codegenapi.ListReferenceDataQuery>({
            query: codegenqueries.listReferenceData,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.ListReferenceDataQuery>).data as codegenapi.ListReferenceDataQuery;
    }

    async gqlListSites(): Promise<codegenapi.ListSitesQuery> {
        return (await GraphQLAPI.graphql<codegenapi.ListSitesQuery>({
            query: codegenqueries.listSites,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
        }) as GraphQLResult<codegenapi.ListSitesQuery>).data as codegenapi.ListSitesQuery;
    }

    async gqlListSitesShallow(): Promise<codegenapi.ListSitesQuery> {
        return (await GraphQLAPI.graphql<codegenapi.ListSitesQuery>({
            query: `
            query ListSites {
                listSites {
                    siteid
                    name
                }
            }
            `,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
        }) as GraphQLResult<codegenapi.ListSitesQuery>).data as codegenapi.ListSitesQuery;
    }

    async gqlListStudies(siteid: string): Promise<codegenapi.ListStudiesQuery> {
        const qv: codegenapi.ListStudiesQueryVariables = { siteid: siteid };
        return (await GraphQLAPI.graphql<codegenapi.ListStudiesQuery>({
            query: codegenqueries.listStudies,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.ListStudiesQuery>).data as codegenapi.ListStudiesQuery;
    }

    async gqlListSubjects(studyid: string): Promise<codegenapi.ListSubjectsQuery> {
        const qv: codegenapi.ListActivityTypesQueryVariables = { studyid: studyid };
        return (await GraphQLAPI.graphql<codegenapi.ListSubjectsQuery>({
            query: `
            query ListSubjects($studyid: ID) {
                listSubjects(studyid: $studyid) {
                    activities {
                        activitytypeid
                    }
                    devices {
                        deviceid
                        position
                    }
                    forms {
                        formtypeid
                    }
                    identifier
                    siteid
                    studyid
                    subjectid
                    status
                }
            }`,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: qv,
        }) as GraphQLResult<codegenapi.ListSubjectsQuery>).data as codegenapi.ListSubjectsQuery;
    }

    async gqlOnActivitiesUpdatesSubscription(subjectid: string): Promise<codegenapi.OnActivitiesUpdatesSubscription | Observable<codegenapi.OnActivitiesUpdatesSubscription>> {
        const sv: codegenapi.OnActivitiesUpdatesSubscriptionVariables = { subjectid: subjectid };
        return (await GraphQLAPI.graphql<codegenapi.OnActivitiesUpdatesSubscription>({
            query: codegensubscriptions.onActivitiesUpdates,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: sv,
        }) as GraphQLResult<codegenapi.OnActivitiesUpdatesSubscription>) as codegenapi.OnActivitiesUpdatesSubscription;
    }

    async gqlOnActivityTypesUpdatesSubscription(studyid: string): Promise<codegenapi.OnActivityTypesUpdatesSubscription | Observable<codegenapi.OnActivityTypesUpdatesSubscription>> {
        const sv: codegenapi.OnActivityTypesUpdatesSubscriptionVariables = { studyid: studyid };
        return (await GraphQLAPI.graphql<codegenapi.OnActivityTypesUpdatesSubscription>({
            query: codegensubscriptions.onActivityTypesUpdates,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: sv,
        }) as GraphQLResult<codegenapi.OnActivityTypesUpdatesSubscription>) as codegenapi.OnActivityTypesUpdatesSubscription;
    }

    async gqlOnDevicesUpdatesSubscription(siteid: string): Promise<codegenapi.OnDevicesUpdatesSubscription | Observable<codegenapi.OnDevicesUpdatesSubscription>> {
        const sv: codegenapi.OnDevicesUpdatesSubscriptionVariables = { siteid: siteid };
        return (await GraphQLAPI.graphql<codegenapi.OnDevicesUpdatesSubscription>({
            query: codegensubscriptions.onDevicesUpdates,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: sv,
        }) as GraphQLResult<codegenapi.OnDevicesUpdatesSubscription>) as codegenapi.OnDevicesUpdatesSubscription;
    }

    async gqlOnFormsUpdatesSubscription(subjectid: string): Promise<codegenapi.OnFormsUpdatesSubscription | Observable<codegenapi.OnFormsUpdatesSubscription>> {
        const sv: codegenapi.OnFormsUpdatesSubscriptionVariables = { subjectid: subjectid };
        return (await GraphQLAPI.graphql<codegenapi.OnFormsUpdatesSubscription>({
            query: codegensubscriptions.onFormsUpdates,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: sv,
        }) as GraphQLResult<codegenapi.OnFormsUpdatesSubscription>) as codegenapi.OnFormsUpdatesSubscription;
    }

    async gqlOnFormTypesUpdatesSubscription(studyid: string): Promise<codegenapi.OnFormTypesUpdatesSubscription | Observable<codegenapi.OnFormTypesUpdatesSubscription>> {
        const sv: codegenapi.OnFormTypesUpdatesSubscriptionVariables = { studyid: studyid };
        return (await GraphQLAPI.graphql<codegenapi.OnFormTypesUpdatesSubscription>({
            query: codegensubscriptions.onFormTypesUpdates,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: sv,
        }) as GraphQLResult<codegenapi.OnFormTypesUpdatesSubscription>) as codegenapi.OnFormTypesUpdatesSubscription;
    }

    async gqlOnReferenceDataUpdatesSubscription(subjectid: string, activitytypeid: string): Promise<codegenapi.OnReferenceDataUpdatesSubscription | Observable<codegenapi.OnReferenceDataUpdatesSubscription>> {
        const sv: codegenapi.OnReferenceDataUpdatesSubscriptionVariables = { subjectid: subjectid, activitytypeid: activitytypeid };
        return (await GraphQLAPI.graphql<codegenapi.OnReferenceDataUpdatesSubscription>({
            query: codegensubscriptions.onReferenceDataUpdates,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: sv,
        }) as GraphQLResult<codegenapi.OnReferenceDataUpdatesSubscription>) as codegenapi.OnReferenceDataUpdatesSubscription;
    }

    async gqlOnSitesUpdatesSubscription(): Promise<codegenapi.OnSitesUpdatesSubscription | Observable<codegenapi.OnSitesUpdatesSubscription>> {
        return (await GraphQLAPI.graphql<codegenapi.OnSitesUpdatesSubscription>({
            query: codegensubscriptions.onSitesUpdates,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
        }) as GraphQLResult<codegenapi.OnSitesUpdatesSubscription>) as codegenapi.OnSitesUpdatesSubscription;
    }

    async gqlOnStudiesUpdatesSubscription(siteid: string): Promise<codegenapi.OnStudiesUpdatesSubscription | Observable<codegenapi.OnStudiesUpdatesSubscription>> {
        const sv: codegenapi.OnStudiesUpdatesSubscriptionVariables = { siteid: siteid };
        return (await GraphQLAPI.graphql<codegenapi.OnStudiesUpdatesSubscription>({
            query: codegensubscriptions.onStudiesUpdates,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: sv,
        }) as GraphQLResult<codegenapi.OnSitesUpdatesSubscription>) as codegenapi.OnStudiesUpdatesSubscription;
    }

    async gqlOnSubjectsUpdatesSubscription(studyid: string): Promise<codegenapi.OnSubjectsUpdatesSubscription | Observable<codegenapi.OnSubjectsUpdatesSubscription>> {
        const sv: codegenapi.OnSubjectsUpdatesSubscriptionVariables = { studyid: studyid };
        return (await GraphQLAPI.graphql<codegenapi.OnSubjectsUpdatesSubscription>({
            query: codegensubscriptions.onSubjectsUpdates,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: sv,
        }) as GraphQLResult<codegenapi.OnSubjectsUpdatesSubscription>) as codegenapi.OnSubjectsUpdatesSubscription;
    }

    async gqlOnSubjectUpdatesSubscription(studyid: string, subjectid: string): Promise<codegenapi.OnSubjectUpdatesSubscription | Observable<codegenapi.OnSubjectUpdatesSubscription>> {
        const sv: codegenapi.OnSubjectUpdatesSubscriptionVariables = { studyid: studyid, subjectid: subjectid };
        return (await GraphQLAPI.graphql<codegenapi.OnSubjectUpdatesSubscription>({
            query: codegensubscriptions.onSubjectUpdates,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: sv,
        }) as GraphQLResult<codegenapi.OnSubjectUpdatesSubscription>) as codegenapi.OnSubjectUpdatesSubscription;
    }

    async gqlRemoveActivity(subjectid: string, activitytypeid: string): Promise<any> {
        const mv: codegenapi.RemoveActivityMutationVariables = { subjectid: subjectid, activitytypeid: activitytypeid };
        return (await GraphQLAPI.graphql({
            query: codegenmutations.removeActivity,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult).data;
    }

    async gqlRemoveActivityType(studyid: string, activitytypeid: string): Promise<any> {
        const mv: codegenapi.RemoveActivityTypeMutationVariables = { studyid: studyid, activitytypeid: activitytypeid };
        return (await GraphQLAPI.graphql({
            query: codegenmutations.removeActivityType,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult).data;
    }

    async gqlRemoveDevice(siteid: string, deviceid: string): Promise<any> {
        const mv: codegenapi.RemoveDeviceMutationVariables = { siteid: siteid, deviceid: deviceid };
        return (await GraphQLAPI.graphql({
            query: codegenmutations.removeDevice,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult).data;
    }

    async gqlRemoveForm(subjectid: string, formtypeid: string): Promise<any> {
        const mv: codegenapi.RemoveFormMutationVariables = { subjectid: subjectid, formtypeid: formtypeid };
        return (await GraphQLAPI.graphql({
            query: codegenmutations.removeForm,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult).data;
    }

    async gqlRemoveFormType(studyid: string, formtypeid: string): Promise<any> {
        const mv: codegenapi.RemoveFormTypeMutationVariables = { studyid: studyid, formtypeid: formtypeid };
        return (await GraphQLAPI.graphql({
            query: codegenmutations.removeFormType,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult).data;
    }

    async gqlRemoveReferenceData(subjectid: string, referencedataid: string): Promise<any> {
        const mv: codegenapi.RemoveReferenceDataMutationVariables = { subjectid: subjectid, referencedataid: referencedataid };
        return (await GraphQLAPI.graphql({
            query: codegenmutations.removeReferenceData,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult).data;
    }

    async gqlRemoveSite(siteid: string): Promise<any> {
        const mv: codegenapi.RemoveSiteMutationVariables = { siteid: siteid };
        return (await GraphQLAPI.graphql({
            query: codegenmutations.removeSite,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult).data;
    }

    async gqlRemoveStudy(siteid: string, studyid: string): Promise<any> {
        const mv: codegenapi.RemoveStudyMutationVariables = { siteid: siteid, studyid: studyid };
        return (await GraphQLAPI.graphql({
            query: codegenmutations.removeStudy,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult).data;
    }

    async gqlRemoveSubject(studyid: string, subjectid: string): Promise<any> {
        const mv: codegenapi.RemoveSubjectMutationVariables = { studyid: studyid, subjectid: subjectid };
        return (await GraphQLAPI.graphql({
            query: codegenmutations.removeSubject,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult).data;
    }

    async gqlUpdateActivity(subjectid: string, activitytypeid: string, startTime: number, stopTime: number, comment: string | undefined | null = null): Promise<codegenapi.GetActivityQuery> {
        const mv: codegenapi.UpdateActivityMutationVariables = {
            input: {
                subjectid: subjectid,
                activitytypeid: activitytypeid,
                startTime: startTime,
                stopTime: stopTime,
                comment: comment,
            }
        };
        return (await GraphQLAPI.graphql<codegenapi.UpdateActivityMutation>({
            query: codegenmutations.updateActivity,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetActivityQuery>).data as codegenapi.GetActivityQuery;
    }

    async gqlUpdateActivityType(studyid: string, activitytypeid: string, description: string): Promise<codegenapi.GetActivityTypeQuery> {
        const mv: codegenapi.UpdateActivityTypeMutationVariables = { activitytypeid: activitytypeid, input: { studyid: studyid, description: description } };
        return (await GraphQLAPI.graphql<codegenapi.UpdateActivityTypeMutation>({
            query: codegenmutations.updateActivityType,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetActivityTypeQuery>).data as codegenapi.GetActivityTypeQuery;
    }

    async gqlUpdateDevice(siteid: string, deviceid: string): Promise<codegenapi.GetDeviceQuery> {
        const mv: codegenapi.UpdateDeviceMutationVariables = { siteid: siteid, deviceid: deviceid };
        return (await GraphQLAPI.graphql<codegenapi.UpdateSiteMutation>({
            query: codegenmutations.updateDevice,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetDeviceQuery>).data as codegenapi.GetDeviceQuery;
    }

    async gqlUpdateForm(subjectid: string, formtypeid: string, fields: codegenapi.KeyValuePairInput[]): Promise<codegenapi.GetFormQuery> {
        const mv: codegenapi.UpdateFormMutationVariables = { input: { subjectid: subjectid, formtypeid: formtypeid, fields: fields } };
        return (await GraphQLAPI.graphql<codegenapi.UpdateFormMutation>({
            query: codegenmutations.updateForm,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetFormQuery>).data as codegenapi.GetFormQuery;
    }

    async gqlUpdateFormType(studyid: string, formtypeid: string, identifier: string, fields: codegenapi.FormTypeFieldInput[] | null | undefined): Promise<codegenapi.GetFormTypeQuery> {
        const mv: codegenapi.UpdateFormTypeMutationVariables = { formtypeid: formtypeid, input: { studyid: studyid, identifier: identifier, fields: fields } };
        return (await GraphQLAPI.graphql<codegenapi.UpdateFormTypeMutation>({
            query: codegenmutations.updateFormType,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetFormTypeQuery>).data as codegenapi.GetFormTypeQuery;
    }

    async gqlUpdateSite(siteid: string, name: string): Promise<codegenapi.GetSiteQuery> {
        const mv: codegenapi.UpdateSiteMutationVariables = { siteid: siteid, name: name };
        return (await GraphQLAPI.graphql<codegenapi.UpdateSiteMutation>({
            query: codegenmutations.updateSite,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetSiteQuery>).data as codegenapi.GetSiteQuery;
    }

    async gqlUpdateSubject(siteid: string, studyid: string, subjectid: string, identifier: string | undefined | null, devices: codegenapi.SubjectDevice[] | undefined | null): Promise<codegenapi.GetSubjectQuery> {
        const mv: codegenapi.UpdateSubjectMutationVariables = {
            input: {
                siteid: siteid,
                studyid: studyid,
                subjectid: subjectid,
                identifier: identifier,
                devices: devices,
                status: codegenapi.SubjectStatusType.OPEN,
            }
        };
        return (await GraphQLAPI.graphql<codegenapi.UpdateSubjectMutation>({
            query: codegenmutations.updateSubject,
            authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS,
            variables: mv,
        }) as GraphQLResult<codegenapi.GetSubjectQuery>).data as codegenapi.GetSubjectQuery;
    }

}
